import { graphql } from "lib/generated/app-service-gql";
import { useGraphQlQuery } from "../useGraphQlClient";

const query = graphql(`
  query integrationSdkToken {
    integrationSdkToken
  }
`);

/** `enabled` off for a surface that only might need Paragon: the token is a request of its own. */
export function useIntegrationSdkToken(enabled = true) {
  const { data, ...rest } = useGraphQlQuery(["integrationSdkToken"], query, [], { enabled });
  return { sdkToken: data?.integrationSdkToken, ...rest };
}
